import { React, useEffect, useContext } from "react";
import { PartnerHeader } from "@cisco/spaces-dash-lib-header";
import { Menu } from "@cisco/spaces-dash-lib-menu";
import { dispatchToStore, fetchDashboardTiles, fetchConfigData } from "@cisco/spaces-dash-lib-redux-store";
import { Loader } from "@cisco/spaces-dash-lib-uicomponent";
import { ToastContainer } from "@cisco/spaces-dash-lib-notification";
import * as singleSpa from "single-spa";
import { useDispatch, useSelector } from "react-redux";
import { HomeMain, HomeMainContent, Wrapper, GlobalStyle } from "./layout.styled";
import { I18nContext } from "../../contexts/i18nContext";

const navItemsJson = {
  menuItems: [
    {
      id: "1",
      label: "Home",
      icon: "home",
      href: "/",
      isSwitcher: false,
      isNew: false,
      isSelected: false
    },
    {
      id: "2",
      label: "User Management",
      icon: "admin-management",
      href: "rbac",
      isSwitcher: false,
      isNew: false,
      isSelected: false
    }
  ],
  drawerItems: []
};

const adminNavItemsJson = {
  menuItems: [
    {
      id: "1",
      label: "Home",
      icon: "home",
      isSwitcher: false,
      isNew: false,
      isSelected: false
    }
  ],
  drawerItems: []
};

function Layout(props) {
  const { documentationLink, activationCount, children, isAdminLogin } = props;
  const i18n = useContext(I18nContext);
  const { data: configData } = useSelector((state) => state?.config?.config);
  const dispatch = useDispatch();

  const { tilesData, dataFetching } = useSelector((state) => state?.dashboardData);

  const handleNavItemClick = (e, item) => {
    e.preventDefault();
    if (item.href) {
      // Use === for strict comparison
      const url = item.href === "/" ? item.href : `/${item.href}`;
      singleSpa.navigateToUrl(url);
    }
  };

  useEffect(() => {
    if (!configData) {
      dispatch(fetchConfigData());
    }
  }, [configData]);

  useEffect(() => {
    i18n.loadNamespaces("spaces-dash-app-home", (err, t) => {
      console.log(`${err} , ${t}`);
      if (!tilesData?.data?.myApps && !dataFetching) {
        dispatchToStore(fetchDashboardTiles());
      }
    });
  }, [tilesData, dataFetching, documentationLink]);

  return (
    <section>
      <GlobalStyle />

      <Wrapper>
        <Loader key={Date.now()} isFullScreen />
        <ToastContainer autoCloseTimeout={0.5} />
        <div>
          <PartnerHeader i18n={i18n} documentationLink={documentationLink} activationCount={activationCount} />
        </div>
        <HomeMain>
          <div>
            <Menu navItems={isAdminLogin ? adminNavItemsJson : navItemsJson} i18nNamespace="nav-menu" navItemClick={handleNavItemClick} />
          </div>
          <HomeMainContent>{children}</HomeMainContent>
        </HomeMain>
      </Wrapper>
    </section>
  );
}
export default Layout;
